// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__GaE2M","loading":"styles_loading__YD_OH"};